import { Link } from "react-router-dom";
import type { Special } from "@/types/content";
import { bannerOf } from "@/lib/content";

interface SpecialShowcaseProps {
  specials: Special[];
}

export default function SpecialShowcase({ specials }: SpecialShowcaseProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
      {specials.map((special, index) => (
        <Link
          key={special.id}
          to={`/special/${special.id}`}
          className="group relative block cursor-pointer overflow-hidden rounded-lg border border-background-300/50"
        >
          <div className={`relative w-full ${index === 0 ? "h-[260px] md:h-[300px]" : "h-[260px] md:h-[300px]"}`}>
            <img
              src={bannerOf(special.banner)}
              alt={`${special.title}专题主图`}
              title={`${special.title} · 亚洲无码精选专题`}
              className="h-full w-full object-cover object-center transition duration-700 ease-smooth group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/60 to-background-950/10" />
          </div>

          <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
            <div className="flex items-center gap-2">
              <span className="rounded bg-primary-500 px-1.5 py-0.5 font-heading text-[10px] font-bold text-background-950">
                专题
              </span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-foreground-400">{special.subtitle}</span>
            </div>
            <h3 className="mt-2 font-heading text-[17px] font-bold leading-snug text-foreground-50">
              {special.title}
            </h3>
            <p className="mt-1.5 line-clamp-2 text-[12px] leading-relaxed text-foreground-400">{special.intro}</p>
            <div className="mt-3 flex items-center justify-between border-t border-foreground-100/10 pt-2.5">
              <span className="text-[11px] text-foreground-500">
                收录 {special.workIds.length} 部 · {special.updatedAt}
              </span>
              <span className="flex items-center gap-1 text-[11px] text-primary-300">
                进入专题
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}